import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/bootstrap/Button';
import Card, { CardBody } from '../../components/bootstrap/Card';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import useDarkMode from '../../hooks/useDarkMode';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import { useMst } from '../../models';
import AuthService from '../../services/AuthService';
import showNotification from '../../components/extras/showNotification';
import { getItem, removeItem, setItem } from '../../lib/localstorage';
import Checks from '../../components/bootstrap/forms/Checks';

const localStorageUserID = getItem('UserID');
const Login = () => {
	const [isSaveUserID, setIsSaveUserID] = useState(localStorageUserID ? true : false);
	const { user: user } = useMst();
	const { darkModeStatus } = useDarkMode();

	const [usernameInput, setUsernameInput] = useState(false);
	const [userid, setUseId] = useState(localStorageUserID ? localStorageUserID : '');
	const [password, setPwd] = useState('');

	const [inputs, setInputs] = useState({
		username: '',
		password: '',
	});
	const navigate = useNavigate();

	const [isPW, setIsPW] = useState(false);
	const [resetPw1, setResetPw1] = useState('');
	const [resetPw2, setResetPw2] = useState('');
	const [contract, setContract] = useState(false);
	const [showContractErr, setShowContractErr] = useState(false);

	const onChangeId = (e) => {
		setUseId(e.target.value);
		// user.setid(e.target.value);
	};
	const onChangepw = (e) => {
		setPwd(e.target.value);
		// user.setpw(e.target.value);
	};

	const handleOnClick = useCallback(
		async (e) => {
			// console.log(e);
			e.preventDefault();
			setPwd('');

			const loginData = {
				email: userid.trim(),
				password: password,
			};
			await AuthService.login(loginData).then(async (res) => {
				// console.log('res ==== ', res);
				if (!res) {
					showNotification('로그인', '접속 권한이 없습니다', 'info');
				} else if (!res?.data && res.message) {
					showNotification('로그인', res.message, 'danger');
				} else {
					// user.setData(res.data);
					await user
						.authMe()
						.then(async () => {
							if (user.me?.type !== 'debriefer' && user.me?.type !== 'admin') {
								showNotification('로그인', '접속 권한이 없습니다', 'info');
							} else if (user.me?.status === 'SUCCESS_WAIT') {
								isSaveUserID ? setItem('UserID', user?.me?.email) : removeItem('UserID');
								setIsPW(true);
							} else {
								isSaveUserID ? setItem('UserID', user.me.email) : removeItem('UserID');
								setItem('user-id', user.me.id);
								navigate('/');
							}
						})
						.catch((err) => console.error(err));
				}
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[navigate, userid, password, user, isSaveUserID],
	);

	return (
		<PageWrapper
			title={'Login'}
			className={'login-bg'}
		>
			<div className='browser-noti'>ICRU는 크롬브라우저에 최적화 되어 있습니다.</div>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow' data-tour='login-page'>
							<CardBody className='login-body'>
								<div
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-lo10-dark': darkModeStatus,
									})}>
									<div className='col'>
									</div>
								</div>
								<div className='text-center h2 fw-bold mb-5 text-muted'>
									Welcome, ICRU Admin
								</div>
								<form className='row g-4' onSubmit={handleOnClick}>
									{isPW ? (
										<>
											<div className='text-center h1 fw-bold mb-5'>비밀번호를 변경해주세요.</div>

											<div className='col-12'>
												<FormGroup id='login-password' isFloating label='새 비밀번호'>
													<Input type='password' autoComplete='password' onChange={(e) => setResetPw1(e.target.value)} value={resetPw1} />
												</FormGroup>
												{showContractErr && !resetPw1 ? <div className='text-danger'>{'* 비밀번호를 입력하세요'}</div> : <div></div>}
											</div>
											<div className='col-12'>
												<FormGroup id='login-password' isFloating label='새 비밀번호 확인'>
													<Input type='password' autoComplete='password' onChange={(e) => setResetPw2(e.target.value)} value={resetPw2} />
												</FormGroup>
												{showContractErr && !resetPw2 ? <div className='text-danger'>{'* 비밀번호를 입력하세요'}</div> : <div></div>}
											</div>
											<div className='row col-12'>
												<div className='text-center mt-4 m-3'>
													<Button
														color='brand'
														className='w-100 py-3 mt-3 mb-3'
														// onClick={() => {
														// 	handleOnClick();
														// }}
														onClick={async () => {
															if (resetPw1 !== resetPw2) {
																showNotification('비밀번호', '입력된 비밀번호가 다릅니다.', 'danger');
																return false;
															}
															if (!contract) {
																showNotification('비밀번호', '보안/개인정보를 확인하세요', 'danger');
																return false;
															}

															await AuthService.changePassword(user?.me?.UserID, resetPw1).then((res) => {
																if (res.data) {
																	showNotification('비밀번호', '비밀번호 변경이 완료되었습니다. 다시 로그인 해주세요.', 'success');
																	removeItem('access-token');
																	removeItem('user-idx');
																	removeItem('refresh-token');
																	removeItem('rootState');
																	setIsPW(false);
																	setResetPw1('');
																	setResetPw2('');
																	window.location.href = '/';
																} else {
																	showNotification('비밀번호', '비밀번호 변경에 실패했습니다. 관리자에게 문의해주세요.', 'danger');
																}
															});
														}}>
														비밀번호 변경
													</Button>
												</div>
											</div>
										</>
									) : (
										<>
											<div className='col-12'>
												<FormGroup id='login-username' isFloating label='아이디 또는 이메일' className='mb-1'>
													<Input name='username' autoComplete='username' onChange={onChangeId} value={userid} />
												</FormGroup>

												<FormGroup id='login-password' isFloating label='비밀번호'>
													<Input name='userpass' type='password' autoComplete='password' onChange={onChangepw} value={password} />
												</FormGroup>

												<div className='mt-3'>
													<Checks
														type='checkbox'
														label='아이디 저장'
														checked={isSaveUserID}
														onClick={() => {
															setIsSaveUserID(!isSaveUserID);
														}}
													/>
												</div>
											</div>
											<div className='col-12'>
												<Button color='brand' className='w-100 py-3' type='submit'>
													로그인
												</Button>
											</div>
										</>
									)}
								</form>
							</CardBody>
						</Card>
						<div className='text-center'>
							<p className='text-muted'>Copyright(c) 2023 지음과깃듬. All Rights Reserved</p>
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default Login;
